export default __webpack_public_path__ + "static/media/halloween-1.935a0757.webp";